import React from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'

import { Card, Skeleton, Typography } from '@chilecompra/react-kit/components'

import AttachmentsWrapper from '../../../components/customs/AttachmentsWrapper.component'
import FormattedDateComponent from '../../../components/customs/FormattedDate.component'
import ProtectByFeatures from '../../../components/Security/ProtectByFeatures'
import ProtectByProfile from '../../../components/Security/ProtectByProfile'

import { onGetPublicTokenDirectDealSummaryThunk } from '../DirectDealSummary.actions'

import {
  CODE_BUSINESS_ATTACHAMENTS_DIRECT_DEAL,
  CURRENCY_TRANSLATION,
  PARTICIPANT_LIST_PREFIX
} from '../../../config/settings/constants'
import { REACT_APP_PARTICIPANT_LIST_URL, REACT_APP_PROVIDERS_URL } from '../../../config/settings/environment'

import { DivColumn, Divider, Grid, LinkButton, Link } from '../DirectDealSummary.styles'

/**
 * The DirectDealSummary's table details.
 */
const DirectDealSummaryDetailTable = props => {
  const { infoAttachments, loading, sheet } = props

  const dispatch = useDispatch()

  const handlerRedirectProviderSheet = () => {
    dispatch(
      onGetPublicTokenDirectDealSummaryThunk({
        callback: publicAccess =>
          window.open(
            `${REACT_APP_PROVIDERS_URL}/ficha/callback?access_token=${publicAccess.token}&rut=${sheet?.providerDni}&expires_in=${publicAccess.expires_in}`
          )
      })
    )
  }

  return (
    <Card enableBorder lineColor="primary" color="blank" padding="32px 24px 0">
      <DivColumn container>
        <Grid item sm={3} xs={12}>
          <Typography color="black1" fontWeight="bold" variant="body2" tabIndex="0">
            Nombre
          </Typography>
        </Grid>
        <Grid item sm xs={12}>
          {loading ? (
            <Skeleton width="70%" />
          ) : (
            <Typography color="black1" variant="body1" tabIndex="0">
              {sheet?.name}
            </Typography>
          )}
        </Grid>
      </DivColumn>
      <Divider />
      <DivColumn container>
        <Grid item sm={3} xs={12}>
          <Typography color="black1" fontWeight="bold" variant="body2" tabIndex="0">
            Descripción
          </Typography>
        </Grid>
        <Grid item sm xs={12}>
          {loading ? (
            <Skeleton width="70%" />
          ) : (
            <Typography color="black1" variant="body1" tabIndex="0">
              {sheet?.description}
            </Typography>
          )}
        </Grid>
      </DivColumn>
      <Divider />
      <DivColumn container>
        <Grid item sm={3} xs={12}>
          <Typography color="black1" fontWeight="bold" variant="body2" width="60%" tabIndex="0">
            Causal de Trato Directo
          </Typography>
        </Grid>
        <Grid item sm xs={12}>
          {loading ? (
            <Skeleton width="70%" />
          ) : (
            <Typography color="black1" variant="body1" tabIndex="0">
              {sheet?.cause}
            </Typography>
          )}
        </Grid>
      </DivColumn>
      <Divider />
      <DivColumn container>
        <Grid item sm={3} xs={12}>
          <Typography color="black1" fontWeight="bold" variant="body2" width="70%" tabIndex="0">
            Justificación del Trato Directo
          </Typography>
        </Grid>
        <Grid item sm xs={12}>
          {loading ? (
            <Skeleton width="70%" />
          ) : (
            <Typography color="black1" variant="body1" tabIndex="0">
              {sheet?.justification}
            </Typography>
          )}
        </Grid>
      </DivColumn>
      <Divider />
      <DivColumn container>
        <Grid item sm={3} xs={12}>
          <Typography color="black1" fontWeight="bold" variant="body2" tabIndex="0">
            Fecha de publicación
          </Typography>
        </Grid>
        <Grid item sm xs={12}>
          {loading ? (
            <Skeleton width="70%" />
          ) : (
            <Typography color="black1" variant="body1" tabIndex="0">
              <FormattedDateComponent date={sheet?.datePublish} includeHours />
            </Typography>
          )}
        </Grid>
      </DivColumn>
      <Divider />
      {sheet?.withPublicity && (
        <>
          <DivColumn container>
            <Grid item sm={3} xs={12}>
              <Typography color="black1" fontWeight="bold" variant="body2" tabIndex="0">
                Fecha de cierre
              </Typography>
            </Grid>
            <Grid item sm xs={12}>
              {loading ? (
                <Skeleton width="70%" />
              ) : (
                <Typography color="black1" variant="body1" tabIndex="0">
                  <FormattedDateComponent date={sheet?.dateClosed} includeHours />
                </Typography>
              )}
            </Grid>
          </DivColumn>
          <Divider />
        </>
      )}
      <DivColumn container>
        <Grid item sm={3} xs={12}>
          <Typography color="black1" fontWeight="bold" variant="body2" tabIndex="0">
            Moneda
          </Typography>
        </Grid>
        <Grid item sm xs={12}>
          {loading && <Skeleton width="70%" />}
          {!loading && sheet?.currency && (
            <Typography color="black1" variant="body1" tabIndex="0">
              {CURRENCY_TRANSLATION[sheet?.currency]?.name} ({CURRENCY_TRANSLATION[sheet?.currency]?.cod})
            </Typography>
          )}
        </Grid>
      </DivColumn>
      <Divider />
      <DivColumn container>
        <Grid item sm={3} xs={12}>
          <Typography color="black1" fontWeight="bold" variant="body2" tabIndex="0">
            Proveedor
          </Typography>
        </Grid>
        <Grid item sm xs={12}>
          {loading ? (
            <Skeleton width="70%" />
          ) : (
            <>
              <LinkButton
                aria-label={`Ver ficha de proveedor: ${sheet?.providerName}`}
                fontSize="16px"
                onClick={handlerRedirectProviderSheet}
                type="button"
              >
                {sheet?.providerName}
              </LinkButton>
              <Typography color="black3" fontSize="16px" tabIndex="0">
                {sheet?.providerDni}
              </Typography>
            </>
          )}
        </Grid>
      </DivColumn>
      <Divider />
      <DivColumn container>
        <Grid item sm={3} xs={12}>
          <Typography color="black1" fontWeight="bold" variant="body2" tabIndex="0">
            Duración del contrato
          </Typography>
        </Grid>
        <Grid item sm xs={12}>
          {loading ? (
            <Skeleton width="70%" />
          ) : (
            <Typography color="black1" variant="body1" tabIndex="0">
              {sheet?.contractDuration}
            </Typography>
          )}
        </Grid>
      </DivColumn>
      <Divider />
      <DivColumn container>
        <Grid item sm={3} xs={12}>
          <Typography color="black1" fontWeight="bold" variant="body2" width="70%" tabIndex="0">
            Fecha de término de ejecución
          </Typography>
        </Grid>
        <Grid item sm xs={12}>
          {loading ? (
            <Skeleton width="70%" />
          ) : (
            <Typography color="black1" variant="body1" tabIndex="0">
              <FormattedDateComponent date={sheet?.contractDateFinish} />
            </Typography>
          )}
        </Grid>
      </DivColumn>
      <Divider />
      <DivColumn container>
        <Grid item sm={3} xs={12}>
          <Typography color="black1" fontWeight="bold" variant="body2" tabIndex="0">
            Categoría del contrato
          </Typography>
        </Grid>
        <Grid item sm xs={12}>
          {loading ? (
            <Skeleton width="70%" />
          ) : (
            <Typography color="black1" variant="body1" tabIndex="0">
              {sheet?.contractCategory}
            </Typography>
          )}
        </Grid>
      </DivColumn>
      <Divider />
      <DivColumn container>
        <Grid item sm={3} xs={12}>
          <Typography color="black1" fontWeight="bold" variant="body2" tabIndex="0">
            Tipo de contrato
          </Typography>
        </Grid>
        <Grid item sm xs={12}>
          {loading ? (
            <Skeleton width="70%" />
          ) : (
            <Typography color="black1" variant="body1" tabIndex="0">
              {sheet?.contractType}
            </Typography>
          )}
        </Grid>
      </DivColumn>
      <Divider />
      <DivColumn container>
        <Grid item sm={3} xs={12}>
          <Typography color="black1" fontWeight="bold" variant="body2" width="60%" tabIndex="0">
            Dirección de entrega o ejecución del servicio
          </Typography>
        </Grid>
        <Grid item sm xs={12}>
          {loading ? (
            <Skeleton width="70%" />
          ) : (
            <>
              <Typography color="black1" variant="body1" tabIndex="0">
                {sheet?.deliveryAddress}, {sheet?.deliveryCommune}, {sheet?.deliveryRegion}
              </Typography>
              {sheet?.deliveryComment && (
                <Typography color="black1" variant="body1" tabIndex="0">
                  {sheet?.deliveryComment}
                </Typography>
              )}
            </>
          )}
        </Grid>
      </DivColumn>
      <Divider />
      <DivColumn container>
        <Grid item sm={3} xs={12}>
          <Typography color="black1" fontWeight="bold" variant="body2" tabIndex="0">
            Archivos adjuntos
          </Typography>
        </Grid>
        <Grid item sm xs={12}>
          {!loading && sheet?.resolution?.subBusiness && sheet?.resolution?.idBusiness && (
            <AttachmentsWrapper
              business={CODE_BUSINESS_ATTACHAMENTS_DIRECT_DEAL}
              subBusiness={sheet.resolution.subBusiness}
              idBusiness={sheet.resolution.idBusiness}
              isPrivate
              canRead
              color="blank"
              showIconList={false}
              typeView="list"
            />
          )}
        </Grid>
      </DivColumn>
      <Divider />
      {sheet?.withPublicity && sheet?.withTechnicalReport && (
        <>
          <DivColumn container>
            <Grid item sm={3} xs={12}>
              <Typography color="black1" fontWeight="bold" variant="body2" tabIndex="0">
                Informe Técnico
              </Typography>
            </Grid>
            <Grid item sm xs={12}>
              {!loading && sheet?.report?.subBusiness && sheet?.report?.idBusiness && (
                <AttachmentsWrapper
                  business={CODE_BUSINESS_ATTACHAMENTS_DIRECT_DEAL}
                  subBusiness={sheet.report.subBusiness}
                  idBusiness={sheet.report.idBusiness}
                  isPrivate
                  canRead
                  color="blank"
                  showIconList={false}
                  typeView="list"
                />
              )}
            </Grid>
          </DivColumn>
          <Divider />
        </>
      )}
      {infoAttachments?.[
        `${CODE_BUSINESS_ATTACHAMENTS_DIRECT_DEAL}|${sheet?.optional?.subBusiness}|${sheet?.optional?.idBusiness}`
      ] &&
      infoAttachments?.[
        `${CODE_BUSINESS_ATTACHAMENTS_DIRECT_DEAL}|${sheet?.optional?.subBusiness}|${sheet?.optional?.idBusiness}`
      ]?.existsData ? (
        <>
          <DivColumn container>
            <Grid item sm={3} xs={12}>
              <Typography color="black1" fontWeight="bold" variant="body2" tabIndex="0">
                Adjuntos opcionales
              </Typography>
            </Grid>
            <Grid item sm xs={12}>
              {!loading && sheet?.optional?.subBusiness && sheet?.optional?.idBusiness && (
                <AttachmentsWrapper
                  business={CODE_BUSINESS_ATTACHAMENTS_DIRECT_DEAL}
                  subBusiness={sheet.optional.subBusiness}
                  idBusiness={sheet.optional.idBusiness}
                  isPrivate
                  canRead
                  color="blank"
                  showIconList={false}
                  typeView="list"
                />
              )}
            </Grid>
          </DivColumn>
          <Divider />
        </>
      ) : null}

      <ProtectByFeatures rule={features => features['participant.list.probidad']}>
        <ProtectByProfile rule={userType => userType === 'Comprador'} fallback={() => null}>
          <DivColumn container>
            <Grid item sm={3} xs={12}>
              <Typography
                color="black1"
                fontSize="14px"
                fontWeight="bold"
                lineHeight="18px"
                variant="body2"
                tabIndex="0"
              >
                Listado de Participantes
              </Typography>
            </Grid>
            <Grid item sm xs={12}>
              {loading ? (
                <Skeleton width="70%" />
              ) : (
                <Link
                  rel="noreferrer"
                  target="_blank"
                  href={`${REACT_APP_PARTICIPANT_LIST_URL}/participantes/${PARTICIPANT_LIST_PREFIX}/${sheet?.code}`}
                >
                  Ir al listado de participantes
                </Link>
              )}
            </Grid>
          </DivColumn>
        </ProtectByProfile>
      </ProtectByFeatures>
    </Card>
  )
}

DirectDealSummaryDetailTable.propTypes = {
  infoAttachments: PropTypes.object,
  loading: PropTypes.bool,
  sheet: PropTypes.shape({
    cause: PropTypes.string,
    code: PropTypes.string,
    contractCategory: PropTypes.string,
    contractDateFinish: PropTypes.string,
    contractDuration: PropTypes.string,
    contractType: PropTypes.string,
    currency: PropTypes.string,
    dateClosed: PropTypes.string,
    datePublish: PropTypes.string,
    deliveryAddress: PropTypes.string,
    deliveryComment: PropTypes.string,
    deliveryCommune: PropTypes.string,
    deliveryRegion: PropTypes.string,
    description: PropTypes.string,
    justification: PropTypes.string,
    name: PropTypes.string,
    providerDni: PropTypes.string,
    providerName: PropTypes.string,
    resolution: {
      subBusiness: PropTypes.number,
      idBusiness: PropTypes.number
    },
    report: {
      subBusiness: PropTypes.number,
      idBusiness: PropTypes.number
    },
    optional: {
      subBusiness: PropTypes.number,
      idBusiness: PropTypes.number
    },
    withPublicity: PropTypes.bool,
    withTechnicalReport: PropTypes.bool
  })
}

export default DirectDealSummaryDetailTable
